import { useEffect } from "react";
import { useMe } from "@hooks/trpc/useMe";
import { identifyUser } from "@utils/sentry";
import { useData, useDataAuth } from "../../../runtime/provider";

/**
 * Adds the profile to the Sentry user. The runtime already named the account
 * (id and email) from the saved sign-in when the app started; once `me` loads
 * this adds the username, and follows a change to either.
 */
export function useSentryProfile() {
  const data = useData();
  const { firebaseUser } = useDataAuth();
  const uid = firebaseUser?.uid;
  const {
    query: { data: user, isPending },
  } = useMe();

  useEffect(() => {
    // Cached profiles can outlive sign-out or an interrupted account reset.
    if (
      !user ||
      isPending ||
      !data.isCurrent() ||
      data.auth.currentUser()?.uid !== user.id
    ) {
      return;
    }
    identifyUser({ id: user.id, email: user.email, username: user.name });
  }, [user, isPending, data, uid]);
}
